module.exports = __webpack_public_path__ + "static/media/post-event-bottom.1e4bcabd.png";